<div
  [ngClass]="{ 'is-open': isOpen, 'nav-closing': !navOpen }"
  class="panel-container"
>
  <ng-content></ng-content>
</div>
